import { dealsDuckCreator } from 'axl-ducks';

const dealsDuck = dealsDuckCreator({
    store: 'deals',
});

export default dealsDuck;
